import { cn } from '@workspace/ui/lib/utils'
import type * as React from 'react'

interface FormFieldProps {
  label: string
  error?: string
  hint?: React.ReactNode
  required?: boolean
  children: React.ReactNode
  className?: string
}

function FormField({ label, error, hint, required = false, children, className }: FormFieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <div className="flex items-center justify-between">
        <div className="text-sm font-medium text-foreground">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </div>
        {hint && <div className="ml-auto text-sm text-muted-foreground">{hint}</div>}
      </div>
      {children}
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  )
}

interface FormGroupProps {
  title?: string
  description?: string
  children: React.ReactNode
  className?: string
}

function FormGroup({ title, description, children, className }: FormGroupProps) {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {(title || description) && (
        <div className="flex flex-col gap-1">
          {title && <h3 className="text-base font-semibold text-foreground">{title}</h3>}
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
      )}
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  )
}

export { FormField, FormGroup }
export type { FormFieldProps, FormGroupProps }
